import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronRight, Recycle } from "lucide-react";

export default function CTASection() {
  return (
    <section className="relative py-20 bg-[#2F5B49] overflow-hidden">
      <img
        src="https://images.unsplash.com/photo-1667755582571-d7b98b88d326?crop=entropy&cs=srgb&fm=jpg&q=60"
        alt=""
        className="absolute inset-0 w-full h-full object-cover opacity-15"
      />
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="font-heading font-bold text-3xl sm:text-4xl text-white mb-5">
          ¿Necesitas solicitar una recogida hoy mismo?
        </h2>
        <p className="text-white/80 mb-10 max-w-xl mx-auto">
          Completa el formulario en menos de 3 minutos y recibe tu ticket de
          confirmación al instante.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/solicitud">
            <Button
              size="lg"
              className="whitespace-normal text-center bg-municipal hover:bg-municipal-dark text-white font-semibold h-14 px-8 text-base shadow-lg"
              data-testid="cta-solicitar-btn"
            >
              Solicitar Recogida de Enseres y/o Poda <ChevronRight className="w-5 h-5 ml-1" />
            </Button>
          </Link>
          <Link to="/punto-limpio">
            <Button
              size="lg"
              className="bg-white hover:bg-gray-100 text-[#2F5B49] font-semibold h-14 px-8 text-base shadow-lg"
              data-testid="cta-puntolimpio-btn"
            >
              <Recycle className="w-5 h-5 mr-2" /> Punto Limpio Móvil
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
